<template>
  <span v-if="themeBar">
    <div class="layout-set-btn" @click="handleOpenThemeBar">
      <i class="iconfont icon-bpm-customization" />
    </div>

    <el-drawer
      :visible.sync="drawerVisible"
      direction="rtl"
      append-to-body
      size="470px"
    >
      <el-scrollbar style="height: 94vh; overflow: hidden">
        <div class="el-drawer__body">
          <div
            v-for="(item, index) in themeConfigList"
            :key="index"
            class="style-set"
            :class="item.className"
          >
            <h3
              class="style-set-title"
              :class="{ 'no-top-margin': item.key === 'style' }"
            >
              {{ item.title }}
            </h3>
            <ul class="styles">
              <li
                v-for="it in item.styleType"
                :key="it"
                :class="item.itemClassName"
                :style="{
                  background: item.key === 'themeColor' ? it : '',
                }"
                @click="handleClick(item.key, it)"
              >
                <i
                  v-if="it === defaultActiveMap[item.key]"
                  class="el-icon-check"
                  :class="{ 'is-theme-active': item.key === 'themeColor' }"
                ></i>
              </li>
            </ul>
            <div v-if="item.key === 'themeColor'" class="custom-theme-color">
              <span class="custom-text">{{ $t('eip.common.custom') }}</span>
              <el-color-picker
                ref="color-picker"
                v-model="theme.themeColor"
                size="mini"
                @change="handleColorChange"
              ></el-color-picker>
            </div>
          </div>
          <el-button
            type="primary"
            class="clear-cache-btn"
            @click="handleSetDefaultTheme"
          >
            {{ $t('eip.nav.clearThemeCache') }}
          </el-button>
        </div>
      </el-scrollbar>
    </el-drawer>
  </span>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { layout as defaultLayout } from '@/config'
  export default {
    name: 'HtThemeBar',
    data() {
      return {
        drawerVisible: false,
        theme: {
          name: 'default',
          style: 'light',
          layout: 'vertical',
          themeColor: '#2F54EB',
        },
        themeConfigList: [
          {
            title: this.$t('eip.nav.styleSettings'),
            key: 'style',
            itemClassName: 'style-item',
            styleType: ['light', 'mashup', 'dark'],
          },
          {
            title: this.$t('eip.nav.themeColor'),
            key: 'themeColor',
            className: 'theme-color-select',
            itemClassName: 'theme-color-item',
            styleType: [
              '#2F54EB',
              '#F5222D',
              '#FA541C',
              '#FAAD14',
              '#13C2C2',
              '#1890FF',
              '#722ED1',
            ],
          },
          {
            title: this.$t('eip.nav.navigationMode'),
            key: 'layout',
            className: 'nav-set',
            itemClassName: 'nav-item',
            styleType: ['vertical', 'horizontal'],
          },
        ],
        defaultActiveMap: {
          style: 'light',
          themeColor: 'default',
          layout: 'vertical',
        },
      }
    },
    computed: {
      ...mapGetters({
        layout: 'settings/layout',
        themeBar: 'settings/themeBar',
        style: 'settings/style',
        themeColor: 'settings/themeColor',
      }),
    },
    created() {
      this.$baseEventBus.$on('theme', () => {
        this.handleOpenThemeBar()
      })
      const theme = localStorage.getItem('eip-front-theme')
      if (null !== theme) {
        this.theme = JSON.parse(theme)
      } else {
        this.theme.layout = this.layout
        this.theme.style = this.style
        this.defaultActiveMap.style = this.style
        this.defaultActiveMap.layout = this.layout
        this.defaultActiveMap.themeColor = this.themeColor
      }
    },
    methods: {
      ...mapActions({
        changeLayout: 'settings/changeLayout',
        changeStyle: 'settings/changeStyle',
        changeThemeColor: 'settings/changeThemeColor',
        changeHeader: 'settings/changeHeader',
      }),
      handleClick(key, it) {
        this.defaultActiveMap[key] = it
        this.theme[key] = it
        this.handleSetTheme()
      },
      handleColorChange(val) {
        this.theme.themeColor = val
        this.handleSetTheme()
      },
      handleIsMobile() {
        return document.body.getBoundingClientRect().width - 1 < 992
      },
      handleOpenThemeBar() {
        this.drawerVisible = true
      },
      handleSetTheme() {
        let { name, layout, style, themeColor } = this.theme
        const themeConfig = {
          name,
          layout,
          style,
          themeColor,
        }
        localStorage.setItem('eip-front-theme', JSON.stringify(themeConfig))
        this.defaultActiveMap.style = style
        this.defaultActiveMap.layout = layout
        this.defaultActiveMap.themeColor = themeColor
        if (!this.handleIsMobile()) this.changeLayout(layout)
        this.changeStyle(style)
        this.changeThemeColor(themeColor)
        document.getElementsByTagName(
          'body'
        )[0].className = `eip-front-theme-default`
        // this.drawerVisible = false
        document.body.style = `--themeColor:${themeColor}; --themeColorRgb:${this.hexToRgba(
          themeColor
        )}`
      },
      handleSaveTheme() {
        this.handleSetTheme()
      },
      handleSetDefaultTheme() {
        document
          .getElementsByTagName('body')[0]
          .classList.remove(`eip-front-theme-default`)
        localStorage.removeItem('eip-front-theme')
        // this.$refs['form'].resetFields()
        Object.assign(this.$data, this.$options.data())
        this.changeHeader(defaultLayout)
        this.theme.themeColor = '#2F54EB'
        this.theme.layout = this.layout
        this.theme.style = this.style
        this.drawerVisible = false
        location.reload()
      },
      hexToRgba(hex) {
        const red = parseInt(`0x${hex.slice(1, 3)}`)
        const green = parseInt(`0x${hex.slice(3, 5)}`)
        const blue = parseInt(`0x${hex.slice(5, 7)}`)
        return `${red},${green},${blue}`
      },
    },
  }
</script>

<style lang="scss" scoped>
  @mixin right-bar {
    position: fixed;
    right: 0;
    z-index: $base-z-index;
    width: 60px;
    min-height: 60px;
    text-align: center;
    cursor: pointer;
    background: $base-color-blue;
    border-radius: $base-border-radius;

    > div {
      padding-top: 10px;
      border-bottom: 0 !important;

      &:hover {
        opacity: 0.9;
      }

      & + div {
        border-top: 1px solid $base-color-white;
      }

      p {
        padding: 0;
        margin: 0;
        font-size: $base-font-size-small;
        line-height: 30px;
        color: $base-color-white;
      }
    }
  }
  @mixin set-theme-item-after {
    &::after {
      position: absolute;
      width: 25px;
      height: 72px;
      content: '';
      background: $base-color-light-black;
      border-radius: 6px 0px 0px 0px;
    }
  }
  @mixin style-item {
    position: relative;
    width: 83px;
    height: 72px;
    margin-left: 20px;
    background-color: $base-color-white;
    border-radius: 6px 6px 0px 6px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  }
  @mixin style-item-before {
    &::before {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 58px;
      height: 54px;
      content: '';
      background: #f0f2f5;
    }
  }
  .el-drawer__body {
    padding: 0 20px 20px 20px;
  }

  .el-drawer__wrapper {
    outline: none !important;

    * {
      outline: none !important;
    }
    ::v-deep {
      .el-drawer__header {
        margin-bottom: 0;
      }
    }
    .style-set {
      position: relative;
      padding-bottom: 32px;
      border-bottom: 1px solid $base-light-border-color;
      .style-set-title {
        margin: 32px 0 23px 0;
      }
      .no-top-margin {
        margin-top: 0;
      }
      .el-icon-check {
        position: absolute;
        right: 21px;
        bottom: 21px;
        font-size: 20px;
        font-weight: bold;
        color: $base-color-default;
      }
      .styles {
        display: flex;
        list-style: none;
        .style-item {
          cursor: pointer;
          @include style-item;
          @include style-item-before;
          &:first-child {
            margin-left: 0;
          }
          &:last-child {
            background-color: $base-color-light-black;
            &::before {
              background: $base-color-black;
            }
          }
          &:nth-child(2) {
            @include set-theme-item-after;
          }
        }
        .nav-item {
          cursor: pointer;
          @include style-item;
          &:first-child {
            @include style-item-before;
            @include set-theme-item-after;
          }
          &:last-child {
            background: #f0f2f5;
            &::after {
              position: absolute;
              width: 83px;
              height: 18px;
              content: '';
              background: $base-color-light-black;
              border-radius: 6px 6px 0px 0px;
            }
          }
        }
      }
    }
    .theme-color-select {
      .theme-color-item {
        position: relative;
        width: 23px;
        height: 23px;
        margin-right: 12px;
        cursor: pointer;
        border-radius: $base-border-radius;
        .is-theme-active {
          right: 2px;
          bottom: 2px;
          color: $base-color-white;
        }
      }
      .custom-theme-color {
        padding-top: 25px;
        .custom-text {
          margin-right: 9px;
          vertical-align: 0.6em;
        }
      }
    }
  }

  .clear-cache-btn {
    margin-top: 40px;
  }
</style>
